export const AppLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-ice font-manrope">
      {children}
    </div>
  );
};
